/**
 * UNAPPROVED DRAFT COPY. Blake signs off before this reaches production (VME-4254).
 *
 * What a customer sees, inline under the expiry field of the identity wizard, when an identity
 * document is expired and no organisation of theirs accepts an expired document of that type.
 *
 * person-api refuses the same document with the same words (its `DocumentExpired` result): the
 * wizard shows that message as it arrives, and the test that pins this constant pins person-api's
 * text too. The two copies are kept equal on purpose, so the customer reads one wording whether
 * the wizard catches the expired date first or person-api refuses the save.
 */
export const EXPIRED_DOCUMENT_BLOCKED_MESSAGE =
  'This document has expired. Check the expiry date, or use a document that has not expired.';
